import React, { useEffect, useState } from "react";
import styled, { withTheme, ThemeProps } from "styled-components/macro";
import { EnumEntitlement } from "@stigg/react-sdk";
import { MoreVertical } from "react-feather";
// @ts-ignore
import { VectorMap } from "react-jvectormap";

import {
  Card as MuiCard,
  CardContent as MuiCardContent,
  CardHeader,
  IconButton,
  Theme,
} from "@mui/material";
import { spacing } from "@mui/system";

import "../../vendor/jvectormap.css";
import getStiggClient from "../../stigg";

const MapContainer = styled.div`
  height: 344px;
`;

const Card = styled(MuiCard)(spacing);

const CardContent = styled(MuiCardContent)`
  &:last-child {
    padding-top: 0;
    padding-bottom: ${(props) => props.theme.spacing(4)};
  }
`;

const cityMarkers = [
  {
    latLng: [39.904202, 116.407394],
    name: "Beijing",
    cityCode: "BJ",
  },
  {
    latLng: [28.70406, 77.102493],
    name: "Delhi",
    cityCode: "DL",
  },
  {
    latLng: [41.00824, 28.978359],
    name: "Istanbul",
    cityCode: "ISB",
  },
  {
    latLng: [40.7127837, -74.0059413],
    name: "New York",
    cityCode: "NY",
  },
  {
    latLng: [34.052235, -118.243683],
    name: "Los Angeles",
    cityCode: "LA",
  },
  {
    latLng: [41.878113, -87.629799],
    name: "Chicago",
    cityCode: "CHI",
  },
  {
    latLng: [32.0853, 34.781769],
    name: "Tel Aviv",
    cityCode: "TLV",
  },
  {
    latLng: [51.507351, -0.127758],
    name: "London",
    cityCode: "LDN",
  },
  {
    latLng: [55.755825, 37.617298],
    name: "Moscow",
    cityCode: "MOW",
  },
];

function WorldMap(props: { theme: ThemeProps<Theme> & { palette: any } }) {
  const stigg = getStiggClient();
  const [countriesEntitlement, setCountriesEntitlement] =
    useState<EnumEntitlement | null>(null);

  const options = (allowedCountries: string[]) => ({
    map: "world_mill",
    regionStyle: {
      initial: {
        fill:
          props.theme.palette.mode === "dark"
            ? "rgba(255, 255, 255, 0.3)"
            : "#e3eaef",
      },
    },
    backgroundColor: "transparent",
    containerStyle: {
      width: "100%",
      height: "100%",
    },
    markerStyle: {
      initial: {
        r: 9,
        fill: props.theme.palette.secondary.main,
        "fill-opacity": 1,
        stroke: "#fff",
        "stroke-width": 7,
        "stroke-opacity": 0.4,
      },
      hover: {
        stroke: "#fff",
        "fill-opacity": 1,
        "stroke-width": 1.5,
      },
    },
    zoomOnScroll: false,
    markers: cityMarkers
      .filter((city) => allowedCountries.includes(city.cityCode))
      .map((city) => ({
        latLng: city.latLng,
        name: city.name,
      })),
  });

  useEffect(() => {
    const getFeature = async () => {
      const entitlement = stigg.getEnumEntitlement({
        featureId: "feature-08-cities",
        options: {
          fallback: {
            hasAccess: true,
            enumValues: ["US", "UK"],
          },
        },
      });
      setCountriesEntitlement(entitlement);
    };
    getFeature();
  }, [stigg]);

  return (
    <Card mb={6}>
      <CardHeader
        action={
          <IconButton aria-label="settings" size="large">
            <MoreVertical />
          </IconButton>
        }
        title="Real-Time"
      />
      <CardContent>
        <MapContainer>
          <VectorMap {...options(countriesEntitlement?.enumValues || [])} />
        </MapContainer>
      </CardContent>
    </Card>
  );
}

export default withTheme(WorldMap);
